<script setup lang="ts">
import { SelectedSongSearchFilter } from "@/models/SelectedSongSearchFilter";
import { SelectOption } from "@/models/frontend-only/SelectOption";

defineProps<{
  placeholder?: boolean;
}>();

const store = useSongSearchStore();
const { t } = useI18n();

function removeFilter(filter: SelectedSongSearchFilter) {
  if (!store.responseData) {
    return;
  }
  const newSelectedFilters = store.responseData.selectedFilters
    .filter((f) => !(f.id === filter.id && f.categoryId === filter.categoryId))
    .map((f) => ({ id: f.id, catId: f.categoryId }));

  store.updateFilters(newSelectedFilters, store.responseData.expandToAllSongs);
}

const sortByOptions = computed<SelectOption[]>(() => [
  {
    label: t("G.LIT_MostRelevant"),
    value: "relevant",
  },
  {
    label: t("G.LIT_Popularity"),
    value: "popularity",
  },
  {
    label: t("G.LIT_CCLIRank"),
    value: "rank",
  },
  {
    label: t("G.LIT_DateAdded"),
    value: "date",
  },
  {
    label: t("G.LIT_Title"),
    value: "title",
  },
]);
</script>

<template>
  <div class="flex w-full flex-wrap items-center justify-between gap-2">
    <div>
      <div
        class="filters"
        v-if="placeholder"
      >
        <Button
          placeholder
          style="width: 200px; height: 1.5em"
        />
      </div>
      <div
        class="filters"
        v-else
      >
        <label class="sr-only">{{ $t("SV.LIT_Filters") }}</label>

        <AddFilterDropdown />

        <Button
          v-for="f of store.responseData?.selectedFilters"
          :key="f.id"
          type="button"
          class="filter-btn"
          @click="removeFilter(f)"
        >
          <FAIcon class="fa-solid fa-times close-icon" />
          <div>
            <div class="type">
              {{ f.categoryTitle }}
            </div>
            <div>{{ f.title }}</div>
          </div>
        </Button>
      </div>
    </div>
    <div class="flex-shrink-0">
      <FormSelect
        id="SortSearchResultsSelect"
        inline
        v-if="placeholder"
        placeholder
        style="width: 250px"
      />
      <FormSelect
        v-else
        :model-value="store.responseData?.sortBy || 'relevant'"
        :label="$t('G.LIT_SortBy')"
        :options="sortByOptions"
        id="SortSearchResultsSelect"
        inline
        @update:model-value="store.onSortByUpdate"
        data-user-search-activity="Sort Results"
      />
    </div>
  </div>
</template>

<style scoped lang="postcss">
#SortSearchResultsSelect {
  :deep() {
    select {
      @apply w-full;
    }
  }
}

.fliters {
  @apply flex flex-wrap items-center gap-2;
}

.filter-btn {
  letter-spacing: unset;
  text-transform: unset;
  font-weight: normal;

  @apply mr-1 mt-1 rounded-lg p-2 px-4 font-sans hover:bg-light-700;
  text-align: left;
  .type {
    @apply text-xs uppercase text-gray-500;
  }
}
</style>
